import React, { useState } from "react";
import Form from "react-bootstrap/Form"
import { Container, Row, Col } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useHistory } from "react-router-dom";
import { useFormFields } from "../libs/hooksLib";
import { onError, Notification } from "../libs/errorLib";

//import "./Login.css";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";

export default function Login() {  
  const { login } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: ""
  });

  function validateForm() {
    return fields.email.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
  
    setIsLoading(true);

    try {
      const session = await login(fields.email, fields.password) 
      if (session) {
        console.log(session)
        
      } else {
        Notification('error', 'Usuario o contraseña inválidos')
      }

    } catch (e) {
        onError(e);
        Notification('error', 'Usuario o contraseña inválidos')
        setIsLoading(false);
    }
  }

  return (
    <div className="content content-dark">
    <Container className="">
      <Row>
      <Col>
        <h1>Ingresa</h1>
        <div className="description">Ingresa a tu cuenta para poder ver tu shows</div>
      </Col>
    </Row>
    <Row style={{ }}>
      <Col md="4">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="email" size="lg">
          <Form.Label>Usuario</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            value={fields.email}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group controlId="password" size="lg">
          <Form.Label>Password</Form.Label>
          <Form.Control
            value={fields.password}
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
        <LoaderButton
            block
            type="submit"
            size="lg"
            isLoading={isLoading}
            disabled={!validateForm()}
        >
            Login
        </LoaderButton>
      </Form>
      </Col>
      </Row>
    </Container>
    </div>
  );
}